<script lang="ts">
  import Form from "../components/Form.svelte";
  import RadioGroup from "../components/RadioGroup.svelte";
  import { domId } from "../lib/dom";
  import Info from "~icons/ph/info";

  let {
    action,
    errors,
    notification: hadNotification,
    booking: hadBooking,
    distress: hadDistress
  }: {
    action: string;
    errors: { [key: string]: string } | null;
    notification?: string| null;
    booking?: string | null;
    distress?: string | null;
  } = $props();

  const options: [string, string][] = [
    ["Yes", "Yes"],
    ["No", "No"],
  ];

  let hadDistressDetail = $state([null, null, null, null]);

  const closeDialogId = domId("close-dialog");
</script>

<Form method="put" {action} class="ui-rhythm">
  <h2 class="ui-title">Confirm claim eligibility</h2>

  <fieldset class="ui-fieldset">
    <legend>Did you receive an email from easyJet informing you that your information was subject to a data breach?</legend>
    <RadioGroup name="client_reports_data_breach_notification" {options} required bind:group={hadNotification} />
  </fieldset>

  <fieldset class="ui-fieldset">
    <legend class="flex items-start">
      Did you make a booking with easyJet between 17 October 2019 and 4 March 2020?
    </legend>
    <RadioGroup name="client_reports_eligible_easyjet_booking" {options} required bind:group={hadBooking} />
    <div class="ui-alert ui-alert-info"><Info/> We are concerned with the date of the booking, not the date of the flight.</div>
  </fieldset>

  <fieldset class="ui-fieldset">
    <legend>When you heard about the data breach, did you suffer distress about the loss of your personal information?</legend>
    <RadioGroup name="distress" {options} required bind:group={hadDistress} />
  </fieldset>

  {#if hadDistress == "No"}
    <fieldset class="ui-fieldset">
      <legend>
        Have you felt worried about fraud, identity theft, or strangers having your personal information due to this
        breach?
      </legend>
      <RadioGroup
        name="distress_detail[one]"
        {options}
        required={hadDistress == "No"}
        bind:group={hadDistressDetail[0]}
      />
    </fieldset>

    <fieldset class="ui-fieldset">
      <legend>
        Have you noticed yourself checking your bank accounts more often, credit score, or online security more than
        before the breach?
      </legend>
      <RadioGroup
        name="distress_detail[two]"
        {options}
        required={hadDistress == "No"}
        bind:group={hadDistressDetail[1]}
      />
    </fieldset>

    <fieldset class="ui-fieldset">
      <legend>
        Have you been less willing to share information, sign up to online services, or make purchases online due to
        the breach?
      </legend>
      <RadioGroup
        name="distress_detail[three]"
        {options}
        required={hadDistress == "No"}
        bind:group={hadDistressDetail[2]}
      />
    </fieldset>

    <fieldset class="ui-fieldset">
      <legend>Have you experienced anxiety or stress as a result of the breach?</legend>
      <RadioGroup
        name="distress_detail[four]"
        {options}
        required={hadDistress == "No"}
        bind:group={hadDistressDetail[3]}
      />
    </fieldset>

    {#if hadDistressDetail.some((option) => option === "Yes")}
      <!-- Clobbers value of "distress" from 3rd question-->
      <input type="hidden" name="distress" value="Yes">
      <h4 class="font-bold underline my-2">IMPORTANT</h4>
      <p>
        You've selected "No" to the initial question regarding distress, however, your further answers signal that you
        have suffered the symptoms of legal distress.
      </p>
      <p>
        By submitting the form, you are agreeing that you've suffered distress as a result of the easyJet data breach.
      </p>

    {:else if hadDistressDetail.every((option) => option === "No")}
      <h4 class="font-bold underline my-2">IMPORTANT</h4>
      <p>
        You've selected "No" to all of the above questions, signaling that you did not suffer any distress due to this
        breach. <b>Distress can include concerns regarding the following</b>:
      </p>
      <div class="prose text-black">
        <ul>
          <li class="list-disc">Were you anxious of your personal details falling into the wrong hands?</li>
          <li>The threat of stolen details resulting in monetary loss</li>
          <li>The inconvenience of monitoring your details to ensure they are not stolen</li>
        </ul>
      </div>
      <p>Would you like to reconsider your answers above?</p>
    {/if}
  {/if}

  {#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}

  <div class="floating-footer">
    <button class="btn btn-ghost" form={closeDialogId}>Cancel</button>
    <button class="btn btn-primary" type="submit">Done</button>
  </div>
</Form>

<form method="dialog" id={closeDialogId}></form>
